import PropTypes from "prop-types";

const Subheadline = ({ subheadline, description }) => {
  return (
    <div className="flex gap-2 mb-4 items-center">
      <div className="flex flex-col gap-1">
        <h2 className="text-2xl font-bold">{subheadline}</h2>
        <p className="text-sm">{description}</p>
      </div>
    </div>
  );
};

Subheadline.propTypes = {
  subheadline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  lottieAnimation: PropTypes.string,
};

export default Subheadline;
